import { call, put, takeLatest } from 'redux-saga/effects';
import {Pharmacies} from '../api/index';
import {toast} from "react-toastify";
import {
    loadedPharmacies,
    SEARCH_REQUEST_PHARMACIES,
    UPDATE_PHARMACY,
    REQUEST_PHARMACY,
    updatedPharmacy,
} from "../actions/pharmacies.action";


export function* updatePharmacy(payload) {
    try {
        yield call(() => Pharmacies.update(payload));
        yield put(updatedPharmacy());
        toast.success('Pharmacie mis à jour');
    } catch (e) {
        let errors = e.response.data.details;
        for (e of errors) {
            toast.error(e['message']);
        }
    }
}

export function* requestPharmacy({payload}) {
    try {
        let pharmacies = yield call(() => Pharmacies.get(payload))
        yield put(loadedPharmacies(pharmacies.data));
    } catch (err){
        toast.error(err.response.data.message);
    }
}

export function* searchPharmacies(payload) {
    try {
        let pharmacies = null;
        if(typeof payload.data !== 'undefined'&&payload.data.search.length > 0) {
            pharmacies = yield call(() => Pharmacies.search(payload.data.search));
        } else {
            pharmacies = yield call(() => Pharmacies.search());
        }
        yield put(loadedPharmacies(pharmacies.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* watchUpdatePharmacy() {
    yield takeLatest(UPDATE_PHARMACY, updatePharmacy)
}

export function* watchSearchPharmacies() {
    yield takeLatest(SEARCH_REQUEST_PHARMACIES, searchPharmacies);
}

export function* watchRequestPharmacy() {
    yield takeLatest(REQUEST_PHARMACY, requestPharmacy);
}




// WEBPACK FOOTER //
// ./src/sagas/pharmacies.saga.js